import { render, staticRenderFns } from "./CsRemoteAccesses.vue?vue&type=template&id=6a84b05e&"
import script from "./CsRemoteAccesses.vue?vue&type=script&lang=js&"
export * from "./CsRemoteAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports